// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__QDRu2","contactRow":"Contact_contactRow__Hj7e7"};